<template>
  <div class="top-hero2">
    <div class="container">
      <div id="challange-target">hidden</div>

      <div class="row marginTop">
        <div class="col-md-12">
          <div class="row text-center">
            <div class="text-white col-md-6 mb-2">
              <span>Order By Reason</span>
              <v-icon color="#039BE5">mdi-history</v-icon>
              <br />

              <v-btn
                @click="getMessages"
                class="m-1 btn btn-outline-secondary"
                color="#ECEFF1"
                text
                small
                >All</v-btn
              >
              <v-btn
                @click="rental"
                class="m-1 btn btn-outline-secondary"
                color="#ECEFF1"
                text
                small
                >Rental</v-btn
              >
              <v-btn
                @click="sell"
                class="m-1  btn btn-outline-secondary"
                color="#ECEFF1"
                text
                small
                >Sell</v-btn
              >
              <v-btn
                @click="buy"
                value="buy"
                class="m-1  btn btn-outline-secondary"
                color="#ECEFF1"
                text
                small
                >Buy</v-btn
              >
              <v-btn
                @click="other"
                value="other"
                class="m-1  btn btn-outline-secondary"
                color="#ECEFF1"
                text
                small
                >Other</v-btn
              >
            </div>

            <div
              class="text-white text-center col-md-6 mb-2"
              style="text-align:center;"
            >
              <span>Search By Name</span>
              <v-icon color="#90A4AE">mdi-history</v-icon>

              <form @submit.prevent="searching">
                <input
                  class="btn btn-outline-light mr-1"
                  v-model="search"
                  style="border-color: white;"
                  type="search"
                  placeholder="Search"
                  aria-label="Search"
                />
                <button class="btn btn-outline-info" type="submit">
                  Search
                </button>
              </form>
            </div>
          </div>

          <v-toolbar color="#01579B" class="top-hero6" dark flat>
            <v-toolbar-title>Manage Messages</v-toolbar-title>
          </v-toolbar>

          <div class="col-md-12 card" v-show="messages.data == ''">
            <v-container fill-height>
              <v-layout align-center>
                <v-flex>
                  <h6 class="display-4">This is Jane - Your assistent</h6>
                  <span class="subheading"
                    >You don´t have any messages at the moment</span
                  >
                  <v-divider class="my-3"></v-divider>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <v-simple-table v-show="messages.data != ''">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Last Name</th>
                  <th class="text-left">Address</th>
                  <th class="text-left">Email</th>
                  <th class="text-left">Phone</th>
                  <th class="text-left">Reason</th>
                  <th class="text-left">Created</th>
                  <th class="text-left">Actions</th>
                  <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="message in messages.data" :key="message.name">
                  <td>{{ message.first_name }}</td>
                  <td>{{ message.last_name }}</td>
                  <td>{{ message.address }}</td>
                  <td>{{ message.email }}</td>
                  <td>{{ message.phone }}</td>
                  <td>{{ message.type }}</td>
                  <td>{{ formatDate(message.created_at) }}</td>

                  <td>
                    <a
                      href="#"
                      @click="edit(message)"
                      style="color: white"
                      class="btn btn-info btn-sm ml-2"
                      >Send a Response
                    </a>

                    <a
                      href="#"
                      @click="remove(message)"
                      style="color: white"
                      class="btn btn-danger btn-sm ml-2"
                    >
                      Delete
                    </a>

                    <a
                      href="#"
                      @click="client(message)"
                      style="color: white"
                      class="btn btn-success btn-sm ml-2"
                    >
                      Make Client
                    </a>
                  </td>

                  <!-- Modal -->
                  <div
                    class="modal fade bd-example-modal-lg"
                    id="userUp"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="addNewLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog modal-lg" role="document">
                      <div class="modal-content p-4">
                        <div class="modal-header">
                          <h5 class="modal-title" id="addNewLabel">
                            Send a Response
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>

                        <v-form>
                          <p>Send a message to the Client</p>
                          <v-textarea
                            v-model="responseMessage"
                            solo
                            label="Message"
                            rows="4"
                          ></v-textarea>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                              color="#1565C0"
                              class="text-white"
                              :disabled="responseMessage == ''"
                              @click.prevent="sendResponse(message)"
                              >Send Message</v-btn
                            >
                          </v-card-actions>
                        </v-form>
                      </div>
                    </div>
                  </div>
                  <!-- close modal  -->
                </tr>
              </tbody>

              <!-- pagination -->
              <pagination
                :data="messages"
                @pagination-change-page="getMessagesPagination"
                :limit="limit"
                :size="size"
                :align="align"
              />
            </template>
          </v-simple-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script
  src="https://code.jquery.com/jquery-3.5.1.slim.min.js"
  integrity="sha384-DfXdz2htPH0lsSSs5nCTpuj/zy4C+OGpamoFVy38MVBnE+IbbVYUew+OrCXaRkfj"
  crossorigin="anonymous"
></script>
<script>
import moment from "moment";
import Swal from "sweetalert2";
export default {
  data() {
    return {
      search: "",
      messages: {},
      responseMessage: "",

      // pagination items
      limit: 2,
      size: "default",
      align: "center"
    };
  },

  created() {
    this.getMessages();
  },

  methods: {
    formatDate(date) {
      return moment(date).format("LLLL");
    },

    searching() {
      let query = this.search;
      window.axios.post("/api/resultMessage?q=" + query).then(res => {
        this.messages = res.data;
      });
    },

    rental() {
      window.axios.get("/api/messagesRental").then(res => {
        this.messages = res.data;
      });
    },

    sell() {
      window.axios.get("/api/messagesSell").then(res => {
        this.messages = res.data;
      });
    },

    buy() {
      window.axios.get("/api/messagesBuy").then(res => {
        this.messages = res.data;
      });
    },
    other() {
      window.axios.get("/api/messagesOthers").then(res => {
        this.messages = res.data;
      });
    },

    // Our method to GET results from a Laravel endpoint
    getMessagesPagination(page = 1) {
      window.axios
        .get("/api/messages?page=" + page)
        .then(res => (this.messages = res.data));
    },

    sendResponse(message) {
      window.axios
        .post("/api/responseMessage", {
          responseMessage: this.responseMessage,
          messengerEmail: message.email
        })
        .then(() => {
          this.getMessages();
        });
    },

    getMessages() {
      window.axios.get("/api/messages").then(res => {
        this.messages = res.data;
      });
    },

    edit(item) {
      console.log(item);
      this.selected = item;
      $("#userUp").modal("show");
    },

    remove(item) {
      alert("Are you sure");
      window.axios.delete("/api/messages/" + item.id).then(() => {
        this.getMessages();
      });
    },

    client(message) {
      window.axios
        .post("/api/createClient", {
          user: message
        })
        .then(() => {
          Swal.fire({
            icon: "success",
            title: "User successfully created",
            text:
              "Hi, Jane here i sent an email to the new user to verify his account"
          });
        });
    }
  }

  // computed: {
  //       sortBy() {
  //         return this.messages.data.filter( (message) => {
  //             return message.type.match(this.type);
  //         });
  //     }
};
</script>
